import { IdNumberCountries } from "src/contexts/documentationArea/domain/IdNumberCountries";
import { DocumentationAreaTypes } from "src/contexts/documentationArea/domain/DocumentationAreaTypes";
import { SpanishIdNumberValidator } from "./ESIdNumberValidator";
import { NifPersonaJuridicaValidator } from "./NifPersonaJuridicaValidator";
import { IdNumberValidator } from "./IdNumberValidator";

export class IdNumberValidatorFactory {
  public static create(
    country: IdNumberCountries,
    entityType: DocumentationAreaTypes = DocumentationAreaTypes.INDIVIDUAL,
  ): IdNumberValidator {
    switch (country) {
      case IdNumberCountries.ES:
        if (entityType === DocumentationAreaTypes.COMPANY) {
          return new NifPersonaJuridicaValidator();
        }
        return new SpanishIdNumberValidator();
      default:
        throw new Error(
          "IdNumberValidatorFactory: Cannot find an IdNumberValidator for the given country",
        );
    }
  }
}
